import React from 'react';


import { Stack } from 'ui/stack';

import { Input } from 'ui/input';

import { formatCount } from '../../helpers/results-format';

interface EditableEnrollmentCellProps {
  value: number;
  onChange: (value: number) => void;
  isDirty?: boolean;
  disabled?: boolean;
  originalValue?: number | null;
}

const EditableEnrollmentCell = ({
  value,
  onChange,
  isDirty,
  disabled,
  originalValue,
}: EditableEnrollmentCellProps) => {
  const [localValue, setLocalValue] = React.useState(String(value));
  const [isFocused, setIsFocused] = React.useState(false);
  const showOriginal = originalValue != null && Number.isFinite(originalValue);

  React.useEffect(() => {
    if (!isFocused) {
      setLocalValue(String(value));
    }
  }, [value, isFocused]);

  const handleCommit = () => {
    setIsFocused(false);
    const parsed = Number(localValue);

    if (Number.isNaN(parsed)) {
      setLocalValue(String(value));

      return;
    }

    const rounded = Math.round(parsed);

    if (rounded !== value) {
      onChange(rounded);
    } else {
      setLocalValue(String(rounded));
    }
  };

  return (
    <Stack sx={{ gap: 0.5 }}>
      <Input
        value={localValue}
        placeholder="0"
        disabled={disabled}
        dirty={isDirty}
        onChange={(e) => setLocalValue(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={handleCommit}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.currentTarget.blur();
          }
        }}
        size="medium"
        sx={{ width: 70 }}
        aria-label="Enrollment override"
        data-testid="editable-enrollment-input"
      />
      {showOriginal && (
        <span className="text-xs text-gray-500">
          Original:{' '}
          <span className="font-medium">{formatCount(originalValue)}</span>
        </span>
      )}
    </Stack>
  );
};

export default EditableEnrollmentCell;
